import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';

import { BACKEND_URL, apiPath } from '../config/apiBase';
const API = apiPath('/api');

/**
 * Fetch active lookup rows for a given category (and optional parent_key for
 * cascading dropdowns like ticket_item under ticket_subtype). Returns:
 *   { lookups, loading, error, refetch }
 */
export default function useLookups(category, parentKey, options = {}) {
  const { includeInactive = false } = options;
  const [lookups, setLookups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!category) {
      setLookups([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const token = localStorage.getItem('token');
      const params = { category };
      if (parentKey !== undefined && parentKey !== null && parentKey !== '') {
        params.parent_key = parentKey;
      }
      if (includeInactive) params.include_inactive = true;

      const res = await axios.get(`${API}/lookups`, {
        withCredentials: true,
        headers: { Authorization: `Bearer ${token}` },
        params,
      });
      setLookups(res.data);
    } catch (e) {
      console.error('useLookups error', e);
      setError(e);
      setLookups([]);
    } finally {
      setLoading(false);
    }
  }, [category, parentKey, includeInactive]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { lookups, loading, error, refetch: fetchData };
}
